import { deepCopy } from '@/utils'
import { userInfoItem } from '@/views/corporate-info/types/index'
import type { Mutation } from 'vuex'

import actionTypes from './actionTypes'
import { State } from './state'

const mutations: { [actionTypes: string]: Mutation<any> } = {
  [actionTypes.SET_CORPORATE_INFO]: (state: State, json: userInfoItem) => {
    state.corporateInfo = deepCopy(json)
    state.corporateInfoCopy = deepCopy(json)
  },
  [actionTypes.SET_CORPORATE_PAGE_STATUS]: (state: State, number: number) => {
    state.corporatePageStatus = number
  },
  [actionTypes.SET_CORPORATE_ID]: (state: State, number: number) => {
    state.corporateId = number
  },
}

export default mutations
